import React, { useState, useEffect } from 'react'
// import Employee from './Employee.css'
import { addEmployee } from '../../../redux/api/employeeApi/EmployeeApi.js';
import { addEmployeeAction } from '../../../redux/reduxSlice/EmployeeSlice.js';
import ProgressBar from '../../../utils/progressBar/ProgressBar';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { updateEmployee } from '../../../redux/api/employeeApi/EmployeeApi.js';
import { updateEmployeeAction } from '../../../redux/reduxSlice/EmployeeSlice.js';
import {
    FormLabel
} from '@chakra-ui/react';
function DealEmployeeForm(props) {
    const { isUpdateMode, dataToEdit, formData: initialFormData, employeeROWID, onNewEmployeeAdded } = props;
    console.log("onNewEmployeeAdded", props.onNewEmployeeAdded);
    const dispatch = useDispatch();
    const [showProgressBar, setShowProgressBar] = useState(false);
    const { closeDrawer } = props;
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const [formData, setFormData] = useState(
        {
            employeeName: "",
            owner: "",
            email: "",
            currency: "",
            taxCode: "",
            iRDNumber: "",
            date: "",
            street: "",
            state: "",
            city: "",
            PinCode: "",
            country: "",
            dateOfBirth: "",
            otherContactDetail: "",
            startDate: "",
            bank: "",
            branch: "",
            phoneNumber: "",
            rate: "",
            timesheetLink: "",
            employeeStatus: "",
            worksheetLink: "",
            vehicleJobLink: "",
            driver: "",
            suffix: "",
            account: "",
            machineJobLink: "",
            nationality: "",
            confirmationDate: "",
            rateHour: "",
        });

    //countries
    const countries = [
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Angola",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Brazil",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Comoros",
        "Congo",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Democratic Republic of the Congo",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "East Timor",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Fiji",
        "Finland",
        "France",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Greece",
        "Grenada",
        "Guatemala",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "Ivory Coast",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Kosovo",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Micronesia",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "North Korea",
        "North Macedonia",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Qatar",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Korea",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Togo",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Vatican City",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Zambia",
        "Zimbabwe"
    ];

    const handleOnClose = () => {

        setFormData({
            employeeName: "",
            owner: "",
            email: "",
            currency: "",
            taxCode: "",
            iRDNumber: "",
            date: "",
            street: "",
            state: "",
            city: "",
            PinCode: "",
            country: "",
            dateOfBirth: "",
            otherContactDetail: "",
            startDate: "",
            bank: "",
            branch: "",
            phoneNumber: "",
            rate: "",
            timesheetLink: "",
            employeeStatus: "",
            worksheetLink: "",
            vehicleJobLink: "",
            driver: "",
            suffix: "",
            account: "",
            machineJobLink: "",
            nationality: "",
            confirmationDate: "",
            rateHour: "",
        })
    };

    useEffect(() => {
        console.log(formData)
    }, [formData])

    // Handle Change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    // Handle Submit
    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     if (formData.employeeName === "" || formData.owner === "") {
    //         toast.error("Please fill all the required fields")
    //         return
    //     }
    //     console.log(formData)
    //     setShowProgressBar(true)
    //     addEmployee(formData)
    //         .then((response) => {
    //             onNewEmployeeAdded()
    //             console.log("Response - ", response);
    //             if (response.data.success) {
    //                 const ROWID = response.data.ROWID
    //                 dispatch(addEmployeeAction({ ROWID, formData }));
    //                 console.log(response)
    //                 setShowProgressBar(false)
    //                 toast.success("Employee added successfully!");
    //                 handleOnClose();
    //                 setFormData()
    //                 setShowProgressBar(false)
    //             }
    //             else {
    //                 // toast.error("Unable to add Employee , Please try again!");
    //                 toast.success("Employee added successfully!");
    //                 handleOnClose();
    //             }
    //         })
    //         .catch((error) => {
    //             console.error("API Error", error);
    //             toast.success("Employee added successfully!");
    //             // toast.error("Failed to add Employee. Please try again.");
    //             handleOnClose();
    //         });
    // }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.employeeName === "" || formData.owner === "") {
            toast.error("Please fill all the required fields")
            return
        }
        console.log(formData)
        setShowProgressBar(true)
        addEmployee(formData)
            .then((response) => {
                // onNewEmployeeAdded()
                console.log("Response - ", response);
                if (response.data.success) {
                    const ROWID = response.data.ROWID
                    dispatch(addEmployeeAction({ ROWID, formData }));
                    console.log(response)
                    setShowProgressBar(false)
                    toast.success("Employee added successfully!");
                    setFormData()
                    setShowProgressBar(false)
                }
                else {
                    toast.error("Unable to add Employee , Please try again!")
                }
            })
            .catch((error) => {
                console.error("API Error", error);
                toast.error("Failed to add Employee. Please try again.");
            });
    }

    return (
        <div style={{ paddingBottom: '20px', }}>

            <form onSubmit={handleSubmit} >
                <div className='row '>
                    <legend style={{ fontSize: 'Large' }} className='sub-headers'>Employee Information</legend>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Employee Name' name='employeeName' value={formData?.employeeName} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Employee Name<span style={{ color: 'red' }}>*</span></FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder=' Owner' name='owner' value={formData?.owner} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Owner<span style={{ color: 'red' }}>*</span></FormLabel>
                    </div>
                </div>
                <div className='row '>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='email' style={{ outline: "none", border: "none" }} placeholder='Email' name='email' value={formData?.email} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Email</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <select className=' rounded' type='text' placeholder="Employee Status" style={{ width: '100%', outline: "none" }} name="employeeStatus" value={formData?.employeeStatus} onChange={handleChange}>
                                <option value="None">None</option>
                                <option value="Underprocess">Underprocess</option>
                                <option value="Waiting on Document">Waiting on Document</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>
                        <FormLabel className="small-label ps-3" style={{ paddingLeft: "6px" }}>Employee Status</FormLabel>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Date Of Birth' name='dateOfBirth' value={formData?.dateOfBirth} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Date Of Birth</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Other Contact Detail' name='otherContactDetail' value={formData?.otherContactDetail} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Other Contact Detail</FormLabel>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Start Date ( with Numberdar )' name='startDate' value={formData?.startDate} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Start Date ( with Numberdar )</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Phone Number' name='phoneNumber' value={formData?.phoneNumber} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Phone Number</FormLabel>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Rate/Hour' name='rateHour' value={formData?.rateHour} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Rate/Hour</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <select className=' rounded' type='text' placeholder="Nationality" style={{ width: '100%', outline: "none" }} name='nationality' value={formData?.nationality} onChange={handleChange}  >
                                <option value="None">None</option>
                                <option value="New Zealand">New Zealand</option>
                                <option value="India">India</option>
                                <option value="USA">USA</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <FormLabel className="small-label ps-3" style={{ paddingLeft: "6px" }}>Nationality</FormLabel>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='d-flex py-3'><span> <input class="form-check-input" type="checkbox" value={formData?.driver} onChange={handleChange} />
                        </span><p className='ps-3'>Driver</p></div>
                    </div>
                </div>

                <div className='row'>
                    <legend style={{ fontSize: 'Large' }} className='sub-headers'>Tax Information</legend>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Tax Code' name='taxCode' value={formData?.taxCode} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Tax Code</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='IRD Number' name='iRDNumber' value={formData?.iRDNumber} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">IRD Number</FormLabel>
                    </div>
                </div>
                <div className='row'>
                    <legend style={{ fontSize: 'Large' }} className='sub-headers'>Bank Details</legend>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Bank' name='bank' value={formData?.bank} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Bank</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Branch' name='branch' value={formData?.branch} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Branch</FormLabel>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Account' name='account' value={formData?.account} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Account</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Suffix' name='suffix' value={formData?.suffix} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Suffix</FormLabel>
                    </div>
                </div>
                <div className='row'>
                    <legend style={{ fontSize: 'Large' }} className='sub-headers'>Link Section</legend>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='url' style={{ outline: "none", border: "none" }} placeholder='Timesheet Link' name='timesheetLink' value={formData?.timesheetLink} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Timesheet Link</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='url' style={{ outline: "none", border: "none" }} placeholder='Vehicle Job Link' name='vehicleJobLink' value={formData?.vehicleJobLink} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Vehicle Job Link</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='url' style={{ outline: "none", border: "none" }} placeholder='Machine Job Link' name='machineJobLink' value={formData?.machineJobLink} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Machine Job Link</FormLabel>
                    </div>
                </div>
                <div className='row'>
                    <legend style={{ fontSize: 'Large' }} className='sub-headers'>Zoho Sheet Section</legend>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='url' style={{ outline: "none", border: "none" }} placeholder='Worksheet Link' name='worksheetLink' value={formData?.worksheetLink} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Worksheet Link</FormLabel>
                    </div>
                </div>
                <div className='row'>
                    <legend style={{ fontSize: 'Large' }} className='sub-headers'>Confirmation Date</legend>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                            <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Date' name='confirmationDate' value={formData?.confirmationDate} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3"> Confirmation Date</FormLabel>
                    </div>
                </div>
                <div>
                    <fieldset>
                        <div className='row'>
                            <legend style={{ fontSize: 'Large' }} className='sub-headers'>Address Information</legend>
                            <div className='row'>
                                <div className='col-lg-8 col-md-4 col-sm-12 mb-2'>
                                    <input className='form-control input-field' type='text' placeholder='street' name="street" value={formData?.street} onChange={handleChange} />
                                    <FormLabel className="small-label ps-3">Street</FormLabel>
                                </div>
                                <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                                    <input className='form-control input-field' type='text' placeholder='city' name="city" value={formData?.city} onChange={handleChange} />
                                    <FormLabel className="small-label ps-3">City</FormLabel>
                                </div>

                                <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                                    <input className='form-control input-field' type='text' placeholder='state' name="state" value={formData?.state} onChange={handleChange} />
                                    <FormLabel className="small-label ps-3">State</FormLabel>
                                </div>
                                <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                                    <input className='form-control input-field' type='text' placeholder='PinCode' name="PinCode" value={formData?.PinCode} onChange={handleChange} />
                                    <FormLabel className="small-label ps-3">PinCode</FormLabel>
                                </div>
                                <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                                    <select className='form-select input-field' name="country" value={formData?.country} onChange={handleChange}  >
                                        <option value="">Select Country</option>
                                        {countries?.map((country, index) => (
                                            <option key={index} value={country}>
                                                {country}
                                            </option>
                                        ))}
                                    </select>
                                    <FormLabel className="small-label ps-3">Country</FormLabel>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <center><div style={{ display: 'inline-block' }} >
                    <div className='gap-3 d-flex'>

                        <button className='create-button-lookUp' onClick={(e) => { handleSubmit(e) }} >Submit</button>
                    </div>
                </div>
                </center>
            </form>
        </div>
    )
}

export default DealEmployeeForm;